module.exports = __webpack_public_path__ + "static/crawling_claw-a748a91c0ba06cafa1804d7afea8d212.jpeg";